import { FC, PropsWithChildren } from "react";

export const EntityGateway: FC<PropsWithChildren> = ({ children }) => (
  <>{children}</>
);
